import { FormInstance } from 'antd';
import React, { useState } from 'react';
interface StepComponentProps {
  steps: { title: string; icon: React.ReactNode }[];
  children: (props: { currentStep: number; onNextStep: () => void; onPrevStep: () => void }) => React.ReactNode;
  form: FormInstance;
  initialStep?: number;
  beforeNextStep?: (nextStep: number) => Promise<boolean> | boolean;
  beforePrevStep?: () => Promise<boolean> | boolean;
}

const StepComponent: React.FC<StepComponentProps> = ({
  steps,
  children,
  form,
  initialStep = 0,
  beforeNextStep,
  beforePrevStep,
}) => {
  const [currentStep, setCurrentStep] = useState(initialStep);
  const onNextStep = async () => {
    try {
      await form.validateFields();

      if (beforeNextStep) {
        const nextStepIndex = currentStep + 1;
        const allow = await beforeNextStep(nextStepIndex);
        if (!allow) return;
      }
      setCurrentStep((prev) => (prev < steps.length - 1 ? prev + 1 : prev));
    } catch (error) {
      console.warn('Validation error:', error);
      return;
    }
  };

  const onPrevStep = async () => {
    if (beforePrevStep) {
      const allow = await beforePrevStep();
      if (!allow) return;
    }
    setCurrentStep((prev) => (prev > 0 ? prev - 1 : prev));
  };
  return (
    <>
      {children({
        currentStep,
        onNextStep,
        onPrevStep,
      })}
    </>
  );
};
export default StepComponent;
